import React from "react";
import { Link } from "react-router-dom";
import PageNotFound from "../assets/images/Pagenotfound.png";

const NotFound = () => {
  return (
    <div
      style={{
        minHeight: "calc(100vh - 80px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        padding: "48px 20px",
        background: "#f8fafc",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "760px",
          padding: "44px 32px",
          border: "1px solid #e5e7eb",
          borderRadius: "12px",
          background: "#ffffff",
          boxShadow: "0 18px 45px rgba(15, 23, 42, 0.08)",
        }}
      >
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            padding: "6px 12px",
            borderRadius: "999px",
            background: "#eef6ff",
            color: "#0b5f95",
            fontSize: "13px",
            fontWeight: 600,
            marginBottom: "22px",
          }}
        >
          <span
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              background: "#0b75bd",
              display: "inline-block",
            }}
          />
          Error 404
        </div>

        <img
          src={PageNotFound}
          alt="Page Not Found"
          style={{
            maxWidth: "340px",
            width: "100%",
            margin: "0 auto 28px",
            display: "block",
          }}
        />

        <h1
          style={{
            margin: "0 0 12px",
            color: "#0f172a",
            fontSize: "32px",
            fontWeight: 700,
            letterSpacing: "0",
          }}
        >
          Page Not Found
        </h1>
        <p
          style={{
            maxWidth: "520px",
            margin: "0 auto 28px",
            color: "#64748b",
            fontSize: "16px",
            lineHeight: 1.6,
          }}
        >
          The page you are looking for does not exist, may have been moved, or
          you may not have permission to access it.
        </p>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "12px",
            flexWrap: "wrap",
          }}
        >
          <Link
            to="/ats-dashboard"
            style={{
              minWidth: "138px",
              padding: "10px 18px",
              borderRadius: "6px",
              background: "#0b5f95",
              color: "#ffffff",
              fontWeight: 600,
              textDecoration: "none",
              boxShadow: "0 8px 18px rgba(11, 95, 149, 0.22)",
            }}
          >
            Go to Dashboard
          </Link>
          <Link
            to="/"
            style={{
              minWidth: "138px",
              padding: "10px 18px",
              borderRadius: "6px",
              border: "1px solid #cbd5e1",
              background: "#ffffff",
              color: "#334155",
              fontWeight: 600,
              textDecoration: "none",
            }}
          >
            Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
